import React from "react";
import { Helmet } from "react-helmet-async";
import { useLanguage } from "../../AutobizTranslateProvider";
import { t } from "autobiz-translate";

const HelmetComponent = () => {
  const { language: currentLanguage } = useLanguage();
  return (
    <Helmet
      htmlAttributes={{ lang: currentLanguage }}
      link={[
        {
          rel: "canonical",
          href: `https://trade.autobiz.com/login`,
        },
      ]}
      title={t("title_meta_data")}
    ></Helmet>
  );
};
export default HelmetComponent;
